import { render, staticRenderFns } from "./ChoiceEditor.vue?vue&type=template&id=74fb60c6&scoped=true&"
import script from "./ChoiceEditor.vue?vue&type=script&lang=ts&"
export * from "./ChoiceEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fb60c6",
  null
  
)

export default component.exports